<script>
import request from '@utils/request'
import vueSignature from 'vue-signature'
import { genderFilter } from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'
import lazyLoadComponent from '@router/lazyload-component'
import { debounce } from 'lodash'
import cloneDeep from 'lodash/cloneDeep'
// base64 to FileObject
const dataURLtoFile = function (dataurl, filename) {
  let arr = dataurl.split(',');
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}

export default {
  filters: {
    genderFilter,
    formatDate,
  },
  components: {
    vueSignature,
    InvoiceForm: () => lazyLoadComponent(import('@components/InvoiceForm')),
    BaseSteps: () => import('@components/BaseSteps'),
  },
  props: {
    propsStoreInvoiceSetting: {
      type: Number,
      default: -1,
    },
    startTab: {
      type: Number,
      default: 1,
    },
    oneStep: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      default: 'edit',
    },
    memberInfo: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      signatureOption: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'white',
      },
      tryingSignature: false,
      activeStep: 1, // 預設值就2，發票放到別的地方
      submitData: {
        taxType: 'B2C',
        taxId: '',
        CarrierType: '0',
        CarrierNum: '',
        LoveCode: '',
        saveTaxInfo: 1,
        ...this.order.invoice,
      },
      width: window.innerWidth,
      stepList: Object.freeze([
        {
          title: '填寫發票資訊',
        },
        {
          title: '簽名確認',
        },
      ]),
      cloneMemberInfo: {}
    }
  },
  computed: {
    signCheck() {
      if (this.oneStep) {
        return '確認'
      } else {
        return '下一步：簽名確認'
      }
    },
    previousStepText() {
      if (this.oneStep) {
        return '取消'
      } else {
        return '上一步'
      }
    },
    dialogTitle() {
      if (this.oneStep && this.activeStep === 1) {
        return '填寫發票資訊'
      }
      if (this.oneStep && this.activeStep === 2) {
        return '簽名確認'
      }
      if (!this.oneStep) {
        return this.storeInvoiceSetting ? '簽名確認' : ''
      }
      return ''
    },
    isMobile() {
      return /Mobi/.test(navigator.userAgent)
    },
    storeInvoiceSetting() {
      // 不等於 -1 代表有資料傳進來，用傳進來的當作主要判斷
      if (this.propsStoreInvoiceSetting !== -1) {
        return this.propsStoreInvoiceSetting
      } else {
        return this.order.storeInvoiceSetting === 1
      }
    },
    vueSignatureHeight() {
      return this.width < 481 ? '500px' : '300px'
    }
  },
  created() {
    if (this.order.invoices && this.order.invoices.length === 0) {
      this.submitData.taxType = 'B2C'
    }
  },
  mounted() {
    // 行動裝置轉向時會將canvas長寬歸零，觸發 resize 來恢復長寬
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 1000)
    window.addEventListener('resize', () => {
      this.width = window.innerWidth
    })
    // 初始化step -> 讓他等於想看到的畫面
    if (this.oneStep) {
      this.activeStep = this.startTab
    }
  },
  watch: {
    activeStep(nvl) {
    },
    memberInfo(nvl) {
      this.cloneMemberInfo = cloneDeep(nvl)
      const valueArr = ['CarrierNum', 'CarrierType', 'taxId', 'taxType', 'LoveCode']
      valueArr.forEach(item => {
        this.$set(this.submitData, item, nvl[item])
      })
    }
  },
  methods: {
    async tryToStore(signature) {
      try {
        const { params, ...other } = this.order
        const storeData = {
          ...other,
          ...this.submitData,
          status: 6,
          signature,
          CarrierNum: this.submitData.CarrierType === '2' ? this.order.phoneNumber : this.submitData.CarrierNum,
        }
        await this.$store.dispatch('order/store', storeData)
        this.$emit('update')
        this.$emit('update:visible', false)
      } catch {

      } finally {

      }

    },
    onBtnClickClearSign() {
      this.$refs.signature.clear()
    },
    onBtnClickUndoSign() {
      this.$refs.signature.undo()
    },
    handleSubmit: debounce(async function () {
      this.tryingSignature = true
      if (this.$refs.signature.isEmpty()) {
        this.$message({
          type: 'error',
          message: '請在框中簽名！',
        })
        this.tryingSignature = false
      } else {
        try {
          const signData = this.$refs.signature.save() // default format is png
          const rid = Math.floor(Math.random() * 5000000)
          await this.handleUpload(dataURLtoFile(signData, `signature_${rid}.png`))
        } catch(error) {
          this.tryingSignature = false
          console.error(error.message)
        }
      }

    }, 1000),
    async handleUpload(file) {
      try {
        const formData = new FormData()
        formData.append('files[]', file)
        formData.append('dir', 'signature')
        this.tryingToUpload = true
        const imgUrl = await request.post('/admin/merchant/media/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        this.tryToStore(imgUrl)
      } catch (error) {
        console.error(error.message)
      }
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    /**
     * @description 下一步要做啥
     */
    async handleNextStep() {
      // 如果只有一個步驟，就發送出去
      await this.$refs.form.validate()
      if (this.oneStep) {
        this.$emit('closeSignaturDialog', 'finish', this.submitData)
        return
      }
      this.activeStep = 2
    },
    /**
     * @description 上一步按鈕點擊function
     */
    previousStep() {
      if (this.oneStep) {
        this.$emit('closeSignature')
      } else {
        this.activeStep = 1
      }

    }
  },
}
</script>

<template>
  <el-dialog :title="dialogTitle" :class="$style.sign" :visible="visible" :fullscreen="isMobile" top="0" append-to-body
    @close="handleClose">
    <div v-if="mode !== 'edit'" :class="$style.info">
      <div class="service">{{ order.params[0].title }}</div>
      <div class="product">{{ order.productName }}</div>
      <p class="booking-date Jost" style="margin-bottom: 5px;">{{ new Date(order.date) | formatDate() }} {{ order.time }}
      </p>
      <div>{{ order.fullName }} {{ order.gender | genderFilter }}</div>
    </div>

    <template v-if="mode === 'edit'">
      <template v-if="storeInvoiceSetting && !oneStep">
        <BaseSteps :active="activeStep" :list="stepList" class="isStyleNormal" />
      </template>
      <template v-if="activeStep === 1 && storeInvoiceSetting">
        <el-form ref="form" :model="submitData" class="el-form-item--normal-margin text-secondary">
          <InvoiceForm :default-value="submitData" />
        </el-form>
        <el-row :gutter="20" style="margin-top:30px;">
          <el-col :span="24"><el-button class="w-100 is-round" type="primary" @click="handleNextStep">{{ signCheck
          }}</el-button></el-col>
          <el-col :span="24"><el-button class="w-100 is-round mt-3" @click="handleClose">取消</el-button></el-col>
        </el-row>
      </template>
      <template v-if="activeStep === 2 || !storeInvoiceSetting">
        <p style="">簽名確認</p>
        <div style="position: relative;">
          <div :class="$style.actions">
            <el-tooltip class="item" effect="dark" content="復原" placement="top">
              <el-button class="is-round fs-2xl p-2" type="text" @click="onBtnClickUndoSign">
                <BaseIcon name="redo"></BaseIcon>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="清除簽名" placement="top">
              <el-button class="is-round fs-2xl p-2" type="text" @click="onBtnClickClearSign">
                <BaseIcon name="trash-alt"></BaseIcon>
              </el-button>
            </el-tooltip>
          </div>
          <vueSignature ref="signature" :class="$style['signature-area']" :sig-option="signatureOption" :w="'100%'"
            :h="vueSignatureHeight"></vueSignature>
        </div>
        <el-row :gutter="20" style="margin-top:30px;">
          <el-col :span="24"> <el-button class="is-round w-100" type="primary" :loading="tryingSignature"
              :disabled="tryingSignature" @click="handleSubmit">確認送出</el-button></el-col>
          <el-col :span="24"><el-button class="is-round w-100 mt-3" @click="previousStep">{{ previousStepText
          }}</el-button></el-col>
        </el-row>
      </template>
    </template>
    <template v-else>
      <el-image :src="order.signature" :class="$style.image">
        <div slot="error">
          圖片載入失敗
        </div>
      </el-image>
    </template>
  </el-dialog>
</template>
<style lang="scss" module>
@import '@design';

.signature-area {
  :global {
    canvas {
      border: 1px solid #c6c6ba;
      border-radius: 8px;
    }
  }
}

.info {
  text-align: center;

  :global {
    .service {
      font-size: 20px;
      line-height: 25px;
      font-weight: 500;
    }

    .product {
      color: $color-primary;
      font-size: 16px;
      line-height: 25px;
    }

    .booking-date {
      line-height: 28px;
      color: $color-primary;
      font-weight: 500;
    }
  }
}

.actions {
  position: absolute;
  top: 0;
  right: 10px;

  :global {
    .item {
      color: #BEC4C6;

      &:hover {
        color: $color-primary;
      }
    }
  }
}

.image {
  height: 300px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(211 211 211 / 0.2);
  margin-top: 40px;
}

.steps {
  display: flex;
  justify-content: center;
  align-items: center;

  @include touch {
    justify-content: flex-start;
  }

  :global {
    .item {
      display: flex;
      align-items: center;
      opacity: 0.3;

      &.active {
        opacity: 1;
      }

      .step {
        color: white;
        background: $color-primary;
        width: 27px;
        height: 27px;
        padding: 0;
        line-height: 25px;
        text-align: center;
        font-size: 12px;
        box-shadow: 0 0 0px 2px $color-primary;
        border: 1px solid white;
        margin-right: 8px;
      }

      .title {}

      &+.item {
        margin-left: 20px;
      }
    }
  }
}

.sign {
  :global {
    @include touch {
      h4 {
        margin-top: 28px !important;
      }

      h4,
      p {
        text-align: left !important;
      }

      .el-dialog__headerbtn {
        top: 41px;
        font-size: 30px;
      }
    }
  }
}
</style>
